<div [formGroup]="parentForm">
    <custom-label [placeholder]="placeholder"></custom-label>
    <p-panel>
        <ng-template pTemplate="header"> 
            <input *ngIf="isMultiple" 
                style="display: none;" 
                id="fileInput" 
                placeholder="{{ placeholder }}" 
                (ngModel)="gridList" 
                class="form-control" 
                [readonly]="true" 
                type="file" 
                (change)="onFileSelected($event)" 
                accept="image/*" multiple
                formControlName="{{nameInput}}"
                [ngClass]="{ 'is-invalid': nombreFormGroup && nombreFormGroup.status === 'INVALID' && (nombreFormGroup.touched == true || isSubmit) }"
                >
            <input *ngIf="!isMultiple" 
                style="display: none;" 
                id="fileInput" 
                placeholder="{{ placeholder }}" 
                (ngModel)="gridList" 
                class="form-control" 
                [readonly]="true" 
                type="file" 
                (change)="onFileSelected($event)" 
                accept="image/*" 
                formControlName="{{nameInput}}"
                [ngClass]="{ 'is-invalid': nombreFormGroup && nombreFormGroup.status === 'INVALID' && (nombreFormGroup.touched == true || isSubmit) }"
                >
            <label for="fileInput" class="custom-file-button" [ngClass]="{ 'is-invalid': nombreFormGroup && nombreFormGroup.status === 'INVALID' && (nombreFormGroup.touched == true || isSubmit) }">Seleccionar Archivos</label> <p>&nbsp;{{ gridList.length }} archivos seleccionados</p>
        </ng-template>
        
        <div *ngIf="gridList != '' && gridList != undefined">
            <div class="grid" *ngFor="let img of gridList; let i = index">
                <div class="
                    col-12
                    sm:col-12
                    md:col-12
                    lg:col-3
                    xl:col-3">
                    <img  [src]="img.base" alt="{{ placeholder }}" style="max-width: 200px; max-height: 200px; width: 100%;"/>
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-12
                    lg:col-3
                    xl:col-3">
                    {{ img.name }}
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-12
                    lg:col-3
                    xl:col-3">
                    {{ img.size | number: '1.2-2' }} KB
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-12
                    lg:col-3
                    xl:col-3">
                    <custom-button
                        [icon]="'pi pi-times'"
                        (click)="del(i)"
                    >
                    </custom-button>
                </div>
            </div>
        </div>
        
    </p-panel>
</div>

<div *ngIf="nombreFormGroup">
    <div *ngIf="nombreFormGroup.status == 'INVALID' && (nombreFormGroup.touched == true || isSubmit)">
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['required']">{{placeholder}}: Es obligatorio.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['minlength']">{{placeholder}}: No tiene el número de caracteres mínimo.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['maxlength']">{{placeholder}}: Supera el número máximo de caracteres.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['pattern']">{{placeholder}}: No tiene el formato correcto.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['email']">{{placeholder}}: No tiene el formato correcto para emails.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['min']">{{placeholder}}: Esta por debajo del valor mínimo permitido.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['max']">{{placeholder}}: Esta por encima del valor máximo permitido.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['mismatch']">{{placeholder}}: No coincide.</p>
    </div>
</div>
